"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useTravelerSelection: ()=>useTravelerSelection
});
const external_react_namespaceObject = require("react");
const getTravelerLabel_cjs_namespaceObject = require("../helpers/getTravelerLabel.cjs");
const getTravelerError_cjs_namespaceObject = require("../helpers/getTravelerError.cjs");
const external_constants_cjs_namespaceObject = require("../constants.cjs");
const defaultInitialValues = {
    rooms: 1,
    adults: 1,
    children: 0,
    childrenAges: {},
    lapInfants: 0
};
function useTravelerSelection({ ageSelectEnabled, errorMessage: externalErrorMessage, initialValues = {}, isInternationalFlight, isWhiteLabel, maxTravelers = external_constants_cjs_namespaceObject.DEFAULT_MAX_TRAVELERS, shouldCountLapInfant = false, shouldAllowInternationalLapInfants }) {
    const startValues = (0, external_react_namespaceObject.useMemo)(()=>({
            ...defaultInitialValues,
            ...initialValues
        }), [
        initialValues
    ]);
    const [rooms, setRooms] = (0, external_react_namespaceObject.useState)(startValues.rooms);
    const [adults, setAdults] = (0, external_react_namespaceObject.useState)(startValues.adults);
    const [children, setChildren] = (0, external_react_namespaceObject.useState)(startValues.children);
    const [childrenAges, setChildrenAges] = (0, external_react_namespaceObject.useState)(startValues.childrenAges);
    const [lapInfants, setLapInfants] = (0, external_react_namespaceObject.useState)(startValues.lapInfants);
    const [errorMessage, setErrorMessage] = (0, external_react_namespaceObject.useState)('');
    const [shouldValidate, setShouldValidate] = (0, external_react_namespaceObject.useState)(false);
    const label = (0, getTravelerLabel_cjs_namespaceObject.getTravelerLabel)({
        adults,
        children,
        lapInfants,
        rooms
    });
    const calculatedErrorMessage = externalErrorMessage ?? (0, getTravelerError_cjs_namespaceObject.getTravelerError)({
        children,
        childrenAges,
        lapInfants,
        ageSelectEnabled,
        isInternationalFlight,
        isWhiteLabel,
        shouldAllowInternationalLapInfants,
        shouldValidate
    });
    if (calculatedErrorMessage !== errorMessage) setErrorMessage(calculatedErrorMessage);
    const passengerCount = adults + children + (shouldCountLapInfant ? lapInfants : 0);
    const remainingTravelerCount = Math.max(maxTravelers - passengerCount, 0);
    const removeChildrenAge = (index)=>{
        const remainingAges = Object.fromEntries(Object.entries(childrenAges).filter(([key])=>Number(key) !== index));
        setChildrenAges(remainingAges);
    };
    const onAdultsChange = (count)=>{
        setAdults(count);
        if (count < lapInfants) setLapInfants(count);
    };
    const onChildrenChange = (count)=>{
        setChildren(count);
        removeChildrenAge(count);
    };
    const onAgesChange = (index, value)=>{
        setChildrenAges({
            ...childrenAges,
            [index]: value
        });
    };
    const triggerValidation = ()=>{
        setShouldValidate(true);
    };
    return {
        label,
        errorMessage,
        rooms,
        adults,
        children,
        childrenAges,
        lapInfants,
        remainingTravelerCount,
        shouldValidate,
        setRooms,
        setAdults: onAdultsChange,
        setChildren: onChildrenChange,
        setChildrenAges: onAgesChange,
        setLapInfants,
        triggerValidation
    };
}
exports.useTravelerSelection = __webpack_exports__.useTravelerSelection;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useTravelerSelection"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
